/**
 * Allowed MIME types for file uploads
 */
export const allowedFileTypes = [
  // Images
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'image/bmp',
  // PDF
  'application/pdf',
  // Documents
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-powerpoint', // .ppt
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'text/plain', // .txt
  'application/rtf', // .rtf
  'application/vnd.oasis.opendocument.text', // .odt
  'application/vnd.oasis.opendocument.spreadsheet', // .ods
  'application/vnd.oasis.opendocument.presentation', // .odp
]

/**
 * Allowed file extensions for file uploads
 */
export const allowedFileExtensions = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.svg',
  '.bmp',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.txt',
  '.rtf',
  '.odt',
  '.ods',
  '.odp',
]

/**
 * Forbidden file extensions for file uploads (security reasons)
 */
export const forbiddenFileExtensions = [
  '.vbs',
  '.exe',
  '.bin',
  '.bat',
  '.chm',
  '.com',
  '.cpl',
  '.crt',
  '.hlp',
  '.hta',
  '.inf',
  '.ins',
  '.isp',
  '.jse',
  '.lnk',
  '.mdb',
  '.pcd',
  '.pif',
  '.reg',
  '.scr',
  '.sct',
  '.shs',
  '.vbe',
  '.vba',
  '.wsf',
  '.wsh',
  '.wsl',
  '.msc',
  '.msi',
  '.msp',
  '.mst',
]

/**
 * Validate that no allowed extension is also in the forbidden list
 * @throws {Error} If there's an overlap between allowed and forbidden extensions
 */
export const validateFileTypeConfig = () => {
  const overlap = allowedFileExtensions.filter((ext) =>
    forbiddenFileExtensions.includes(ext.toLowerCase())
  )
  if (overlap.length > 0) {
    throw new Error(
      `Configuration error: The following extensions are both allowed and forbidden: ${overlap.join(', ')}`
    )
  }
}

// Validate configuration on module load
validateFileTypeConfig()

/**
 * Generate accept string for HTML file input from allowed extensions
 * @returns {string} Comma-separated list of file extensions (e.g., ".jpg,.png,.pdf")
 */
export const getAcceptString = () => {
  return allowedFileExtensions.join(',')
}
